var map = {
	"./insurance_01.webp": 6882,
	"./insurance_02.webp": 4531,
	"./insurance_03.webp": 7776,
	"./insurance_04.webp": 2905,
	"./insurance_05.webp": 1470,
	"./title_background.webp": 1839,
	"./title_background_sp.webp": 595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2995;